import { Container } from 'reactstrap';
import styles from './ClientBanner.module.scss';
import classNames from 'classnames';
function Skeleton() {
  return <div className={'banners client-banner skeleton-section'} data-bdd={'client-skeleton-banner'} data-sentry-component="Skeleton" data-sentry-source-file="ClientBannerSkeleton.tsx">
   <div className={styles['banner-background-image'] + ' skeleton-loading'}>
    <div className="org-image-skeleton" />
    <div className={classNames(styles['the-client'], styles['with-hero-banner'], 'org-client-hero-container')}>
     <div className={styles['company-logo'] + ' org-logo-skeleton'} data-bdd={'client-logo'}></div>

     <div className={styles['client-details']}>
      <h2 className={'client-banner-heading-skeleton'}></h2>
      <p className="org-resource-skeleton"></p>
     </div>
    </div>

    <Container className={styles['client-banner-strapline']} data-sentry-element="Container" data-sentry-source-file="ClientBannerSkeleton.tsx">
     <p className={'client-banner-strapline-skeleton'}></p>
    </Container>
   </div>
  </div>;
}
export default Skeleton;